import React from 'react';
import { uuid } from 'uuidv4';
import RenderSlice from "./renderSlice";

const RenderTimeslot = ({
  onDeleteTimeslot,
  connectedExperts,
  growlStore
}) => {
  return /*#__PURE__*/React.createElement("div", {
    key: uuid(),
    className: "timeslot",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeslot-content",
    id: "timeslot-content"
  }, /*#__PURE__*/React.createElement("div", {
    id: "renderSlice"
  }, RenderSlice(onDeleteTimeslot, connectedExperts, growlStore))));
};

export default RenderTimeslot;